import { actionConstants } from '../actions/actionConstants';

const initState = {
  loading: false,
  isSubmitting: false,
  users: [],
  isAuthorized: false,
  invitations: [],
  invitationInfo: {},
  errorText: {},
  error: '',
};

const accountReducer = (state = initState, action) => {
  var _state = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case actionConstants.CLEAR_ERROR:
      return { ...state, error: '' };
    case actionConstants.START_QUERY:
      _state.loading = true;
      return _state;
    case actionConstants.END_QUERY:
      _state.loading = false;
      return _state;
    case actionConstants.START_SUBMISSION:
      return { ...state, isSubmitting: true, error: '' };
    case actionConstants.END_SUBMISSION:
      return { ...state, isSubmitting: false };
    case actionConstants.LOGIN_REQUEST:
      return { ...state, error: '' };
    case actionConstants.LOGIN_SUCCESS:
      return { ...state, isAuthorized: true };
    case actionConstants.LOGIN_FAILURE:
      return { ...state, error: action.data };

    case actionConstants.GET_USERS_SUCCESS:
      _state.users = action.data;
      return _state;
    case actionConstants.GET_USERS_FAILURE:
      _state.users = [];
      return _state;

    case actionConstants.REGISTER_SUCCESS:
      _state.registeredStatus = true;
      return _state;
    case actionConstants.REGISTER_FAILURE:
      _state.registeredFailed = action.data;
      return _state;

    case actionConstants.INVITE_USER_SUCCESS:
      _state.invitationID = action.data;
      _state.isInvited = true;
      return _state;
    case actionConstants.INVITE_USER_FAILURE:
      return _state;

    case actionConstants.GET_INVITATIONS_SUCCESS:
      _state.invitations = action.data;
      return _state;
    case actionConstants.GET_INVITATIONS_FAILURE:
      _state.invitations = [];
      return _state;

    case actionConstants.QUERY_INVITATION_SUCCESS:
      _state.invitationInfo = action.data;
      return _state;
    case actionConstants.QUERY_INVITATION_FAILURE:
      _state.errorText = action.data;
      return _state;

    case actionConstants.RESET_PASSWORD_SUCCESS:
      _state.isReset = true;
      return _state;
    case actionConstants.RESET_PASSWORD_FAILURE:
      _state.errorText = action.data;
      return _state;
    case actionConstants.CHANGE_PASSWORD_FAILURE:
      return { ...state, error: action.data };

    case actionConstants.LOGOUT_REQUEST:
      // _state = {};
      return _state;
    default:
      return _state;
  }
};

export default accountReducer;
